<template>
  <svg
    :class="$options.name"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 1100 57"
  >
    <title id="ETlogo" lang="en">ET logo</title>

    <g class="st0">
      <path
        class="st1"
        d="M0,56.3V0.9h35.1v4.3H4.7v20.5h29.8V30H4.7V52h30.4v4.3H0z"
      />
      <path
        class="st1"
        d="M113.9,56.3l-19.3-25l-19.3,25h-5.9l22.2-28.4l-21-27h6l17.9,23.5l18-23.5h6l-21,26.9l22.2,28.5H113.9z"
      />
      <path
        class="st1"
        d="M156.1,56.3V0.9h20.7c10.6,0,16.7,7.5,16.7,16.2c0,8.7-6.1,16.2-16.7,16.2h-16v23H156.1z M188.6,17.1
          c0-7-4.8-11.9-12.2-11.9h-15.5V29h15.5C183.8,29,188.6,24,188.6,17.1z"
      />
      <path
        class="st1"
        d="M231.4,56.3V0.9h35.1v4.3h-30.4v20.5h29.8V30h-29.8V52h30.4v4.3H231.4z"
      />
      <path
        class="st1"
        d="M338.6,56.3L323,33.4h-12.2v22.9h-4.7V0.9h20.7c9.5,0,16.8,6.1,16.8,16.2c0,10-7.1,15.6-15.4,15.9l16,23.2
          H338.6z M338.6,17.1c0-7-4.9-11.9-12.3-11.9h-15.5V29h15.5C333.7,29,338.6,24.1,338.6,17.1z"
      />
      <path class="st1" d="M383.3,56.3V0.9h4.7v55.4H383.3z" />
      <path
        class="st1"
        d="M429.7,56.3V0.9h35.1v4.3h-30.4v20.5h29.8V30h-29.8V52h30.4v4.3H429.7z"
      />
      <path
        class="st1"
        d="M544,56.3L509.1,8.7v47.6h-4.7V0.9h4.8l34.7,46.9V0.9h4.7v55.4H544z"
      />
      <path
        class="st1"
        d="M588.2,28.6c0-17,12.4-28.6,28.1-28.6c8.8,0,15.5,3.9,20.2,9.8l-4,2.6c-3.5-4.8-9.5-8-16.2-8
          c-12.9,0-23.1,9.9-23.1,24.3c0,14.3,10.1,24.3,23.1,24.3c6.6,0,12.7-3.2,16.2-8.1l4.1,2.5c-5,6.1-11.5,9.9-20.3,9.9
          C600.6,57.3,588.2,45.6,588.2,28.6z"
      />
      <path
        class="st1"
        d="M673.9,56.3V0.9H709v4.3h-30.4v20.5h29.8V30h-29.8V52H709v4.3H673.9z"
      />
    </g>
    <g class="st0">
      <path
        class="st2"
        d="M759.9,56.3v-45h-16.2V0.9h44.2v10.4h-16.1v45H759.9z"
      />
      <path
        class="st2"
        d="M861.3,56.3V32.9h-26.1v23.3h-11.8V0.9h11.8v21.7h26.1V0.9h11.9v55.4H861.3z"
      />
      <path class="st2" d="M911.9,56.3V0.9h11.8v55.4H911.9z" />
      <path
        class="st2"
        d="M958.7,48.5l6.5-9.2c3.9,4.1,10,7.6,17.6,7.6c6.6,0,9.6-2.9,9.6-6.1c0-9.6-31.9-2.9-31.9-23.7
          c0-9.2,8-16.8,21-16.8c8.8,0,16.1,2.7,21.6,7.7l-6.6,8.8c-4.5-4.1-10.5-6.1-16.1-6.1c-5,0-7.8,2.2-7.8,5.5
          c0,8.7,31.8,2.8,31.8,23.5c0,10.1-7.3,17.8-22.2,17.8C971.6,57.3,964,53.7,958.7,48.5z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ETLogoText',
  props: {
    width: {
      type: [Number, String],
      default: 200,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
  },
}
</script>

<style lang="scss" scoped>
.st0 {
  enable-background: new;
}
.st1 {
  fill: #ffff;
}
.st2 {
  fill: #ffff;
}
</style>
